/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowConcertNightTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowConcertNight,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Rock the Night!",
    "Concert Adventure Awaits!",
    "Live Music Vibes!",
  ],
  title: "Concert Night",
  description: "Plan an exciting night out at a concert.",
  longDescription:
    "Get ready for a night of live music! Choose the date, pick the concert, and decide on dinner or snacks beforehand!",
  emoji: "🎶",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Concert Night",
          emoji: "🎶",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we go to the concert?",
          emoji: "📅",
          completeAction: {
            question: "Decide on which concert to attend?",
            description: "Which concert do we want to see?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What concert should we attend?",
                emoji: "🎤",
                completeAction: {
                  question: "Decide on dinner or snacks?",
                  description: "What should we eat before the concert?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What dinner should we have?",
                      emoji: "🍽",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Get Ready to Jam!",
    outroDescription:
      "Your concert night plans are set! Enjoy the music and atmosphere!",
  },
};
